import { encodeBase64 } from "../../utils/utilityFunctions";
import { CALL_API } from "../middleware";
import { NomineeType } from "../types/api-types";
import { BSE_NOMINEE_RESEND_OTP, BSE_NOMINEE_RESEND_OTP_SUCCESS, BSE_NOMINEE_SUBMIT_GEN_OTP, BSE_NOMINEE_SUBMIT_GEN_OTP_SUCCESS, NOMINEE_MODIFICATION, NOMINEE_MODIFICATION_SUCCESS } from "../types/nominee";

export interface initiateNomineeModificationBody {
    nominees: NomineeType & { applicationId?: string }[];
    clientCode: string;
}
export interface initiateNomineeModificationRes {
    isSuccess: boolean
    cancelOrder: boolean
    id: string
    token: string
    maximum_attemps: string
    failed_attempts: number
    cartId: any
    message: string
}

export interface submitNomineeBSEValidateOtpRes {
    isSuccess?: boolean
    code?: string
    message?: string
    isBseSuccess?: boolean|null
}

export interface resendNomineeBSEValidateOtpRes {
    isSuccess: boolean
    cancelOrder: boolean
    id: number
    token: string
    maximum_attemps: string
    failed_attempts: number
    cartId: any
    message: string
}

export const initiateNomineeModification =
    (body: any) =>
        async (dispatch: any): Promise<initiateNomineeModificationRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/initiate-nominee-modification',
                    method: 'POST',
                    types: [NOMINEE_MODIFICATION_SUCCESS, NOMINEE_MODIFICATION],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        }

export const submitNomineeBSEValidateOtp =
    (body: {
        otp: string;
        token: string;
        portal?: string;
        id?: number | string;
    }) =>
        async (dispatch: any): Promise<submitNomineeBSEValidateOtpRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/validate-nominee-modification',
                    method: 'POST',
                    types: [BSE_NOMINEE_SUBMIT_GEN_OTP_SUCCESS, BSE_NOMINEE_SUBMIT_GEN_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const resendNomineeBSEValidateOtp =
    (body: {
        token: string;
        id?: number | string;
    }) =>
        async (dispatch: any): Promise<resendNomineeBSEValidateOtpRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/resend-modification-otp',
                    method: 'POST',
                    types: [BSE_NOMINEE_RESEND_OTP_SUCCESS, BSE_NOMINEE_RESEND_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };